import { z } from 'zod';

import { certificateRoleEnum } from '~/modules/clients/common';
import {
  zodFeaturesSchema,
  zodStrategicMultiplierSchema,
} from '~/modules/clients/companyAccounts/utils';

import {
  EmailSchema,
  PhoneNumberSchema,
  withoutObjectKeysWhereValueIs,
} from '@vestigas/utils';

export const zodUpdateCompanyAccountEndpointSchema = z.tuple([
  z.literal('company_account'),
  z.uuid(),
]);

export const zodUpdateCompanyAccountPayloadSchema = z
  .object({
    name: z.string().trim().min(1),
    data: z.object({
      defaultSignatureRole: z
        .union([z.literal(''), certificateRoleEnum])
        .nullish()
        .transform((value) => value ?? ''),
      featureFlags: z.object(zodFeaturesSchema),
      supportEmail: z
        .union([EmailSchema, z.literal('')])
        .nullish()
        .transform((value) => value || null),
      supportPhoneNumber: z
        .union([PhoneNumberSchema, z.literal('')])
        .nullish()
        .transform((value) => value || null),
    }),
    strategicMultiplier: zodStrategicMultiplierSchema.optional(),
  })
  .transform((data) => withoutObjectKeysWhereValueIs(data, [undefined]));
